module.exports = __webpack_public_path__ + "img/flow1.4767d91d.png";